import React, { ReactElement } from 'react'

import Container from './Container'

interface TermsAndConditionsProps {
    onClose: () => void
    url?: string
}

const TermsAndConditions = ({
    onClose,
    url,
}: TermsAndConditionsProps): ReactElement => {
    return (
        <Container
            onClose={onClose}
            url={
                url ?? process.env.REACT_APP_EXTERNAL_LINK_TERMS_AND_CONDITIONS
            }
        />
    )
}

export default TermsAndConditions
